import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const BurgerSvg = () => (
  <svg
    width='1em'
    height='0.75em'
    viewBox='0 0 17 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.386719 1C0.386719 0.447715 0.834434 0 1.38672 0H15.3867C15.939 0 16.3867 0.447715 16.3867 1C16.3867 1.55228 15.939 2 15.3867 2H1.38672C0.834434 2 0.386719 1.55228 0.386719 1Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.386719 6C0.386719 5.44772 0.834434 5 1.38672 5H15.3867C15.939 5 16.3867 5.44772 16.3867 6C16.3867 6.55228 15.939 7 15.3867 7H1.38672C0.834434 7 0.386719 6.55228 0.386719 6Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.386719 11C0.386719 10.4477 0.834434 10 1.38672 10H15.3867C15.939 10 16.3867 10.4477 16.3867 11C16.3867 11.5523 15.939 12 15.3867 12H1.38672C0.834434 12 0.386719 11.5523 0.386719 11Z'
      fill='currentColor'
    />
  </svg>
);

export const BurgerIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BurgerSvg} {...props} />
);
